import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export type PlanChargeStatus = 'paid' | 'processing' | 'canceled' | 'failed' | 'refunded' | string;

export interface PlanChargeItem {
	_id: string;
	createdAt: string;
	description: string;
	amount: number;
	chargeStatus: PlanChargeStatus;
	paymentMethod: string | null;
}

export interface PlanChargesResponse {
	docs: PlanChargeItem[];
	totalDocs: number;
	page: number;
	limit: number;
	totalPages: number;
}

export const useGetPlanCharges = (page = 1, limit = 5) =>
	useQuery({
		queryKey: ['plan-charges', page, limit],
		queryFn: async () => {
			const { data } = await api.get<PlanChargesResponse>('/user/plan/charges', {
				params: { limit, page },
			});
			return data;
		},
		placeholderData: (previousData) => previousData,
	});
